import { AlertTriangle, Check, X } from 'lucide-react'
import * as React from 'react'
import { cn } from '../../lib/cn'
import { Icon } from '../atoms/Icon'

/**
 * ChecklistItem — Done / Warning / Error line in a checklist or validation list.
 * Pencil fFRcK 3X89L WV0qF.
 */
export interface ChecklistItemProps extends React.HTMLAttributes<HTMLDivElement> {
  status: 'done' | 'warning' | 'error' | 'pending'
  label: React.ReactNode
  description?: React.ReactNode
}

const statusIcon = {
  done: { icon: Check, color: 'text-ia-success bg-ia-success-bg' },
  warning: { icon: AlertTriangle, color: 'text-ia-warning bg-ia-warning-bg' },
  error: { icon: X, color: 'text-ia-error bg-ia-error-bg' },
  pending: { icon: Check, color: 'text-ia-text-tertiary bg-ia-elevated' },
} as const

export const ChecklistItem = React.forwardRef<HTMLDivElement, ChecklistItemProps>(
  ({ className, status, label, description, ...props }, ref) => {
    const { icon, color } = statusIcon[status]
    return (
      <div ref={ref} className={cn('flex items-start gap-3 py-2', className)} {...props}>
        <div
          className={cn('flex h-6 w-6 shrink-0 aspect-square items-center justify-center rounded-pill', color)}
        >
          <Icon icon={icon} size="xs" />
        </div>
        <div className="flex flex-col gap-[2px] min-w-0 flex-1">
          <div className="text-body-sm text-ia-text">{label}</div>
          {description && <div className="text-caption text-ia-text-secondary">{description}</div>}
        </div>
      </div>
    )
  },
)
ChecklistItem.displayName = 'ChecklistItem'
